import React, { Component } from 'react'
import api from '../../../../api'

export default class Reports extends Component {

  state = {
    teamsReportSendingTo: null,
    teamsReportLoading: false,
  }

  requestTeamsReport = () => {
    this.setState({ teamsReportLoading: true })
    api.post('/reports/teams').then(resp => {
      this.setState({ 
        teamsReportLoading: false,
        teamsReportSendingTo: resp.data.sending_to,
      })
    })
  }

  getTeamsReportButton() {
    const { teamsReportLoading, teamsReportSendingTo } = this.state
    if (teamsReportSendingTo) {
      return <span>Report will be emailed to {teamsReportSendingTo} when ready.</span>
    } else if (teamsReportLoading) {
      return <span>Loading...</span>
    } else {
      return <button className="button" onClick={this.requestTeamsReport}>Generate Teams Report</button>
    }
  }
  
  render() {
    return (
      <div className="container padded reports">
        <div className="panel full padded">
          <h2 className="title">Reports</h2>
          {this.getTeamsReportButton()}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// client/components/sections/Admin/Reports/index.js